export default __webpack_public_path__ + "static/media/logo.0201c7a7.svg";